import { render, staticRenderFns } from "./DelegatedUsers.vue?vue&type=template&id=58a64c2d&"
import script from "./DelegatedUsers.vue?vue&type=script&lang=js&"
export * from "./DelegatedUsers.vue?vue&type=script&lang=js&"
import style0 from "./DelegatedUsers.vue?vue&type=style&index=0&id=58a64c2d&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a64c2d')) {
      api.createRecord('58a64c2d', component.options)
    } else {
      api.reload('58a64c2d', component.options)
    }
    module.hot.accept("./DelegatedUsers.vue?vue&type=template&id=58a64c2d&", function () {
      api.rerender('58a64c2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/DelegatedUsers.vue"
export default component.exports